/**
 * LDS supplement `ourFare` from initLdsSupplements / computeSupplementPriceIls is
 * already authoritative ILS. Display must NOT run catalogue convertPrice (currentRate),
 * or amounts drift by ~×FX (e.g. ₪180 → ₪665 when rate≈3.7).
 */

const LUGGAGE_TYPES = new Set(["LUGGAGE", "BAGGAGE", "TROLLEY"]);

export function isLdsLuggageSupplementType(type) {
  return LUGGAGE_TYPES.has(String(type || "").toUpperCase());
}

/**
 * @returns {boolean} true → format as ledger ILS (formatAgentWalletAmountIls);
 *   false → caller may use convertPrice / B2C USD dual display.
 */
export function shouldFormatSupplementOurFareAsAuthoritativeIls({
  type,
  isCustomerLink = false,
  b2cUsdPrimaryWithIlsHint = false,
} = {}) {
  if (!isLdsLuggageSupplementType(type)) return false;
  // B2C customer link with dual USD/ILS hint keeps its own path.
  if (isCustomerLink && b2cUsdPrimaryWithIlsHint) return false;
  return true;
}

export function normalizeSupplementOurFareIlsAmount(amount, { roundUp = false } = {}) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return null;
  return roundUp ? Math.ceil(n) : n;
}
